import React, { useMemo } from "react";
import { shallowEqual, useSelector } from "react-redux";

import objectPath from "object-path";

// LayoutContext
import { useHtmlClassService } from "../_core/MetronicLayout";

import { Aside } from "./aside/Aside";
import { QuickPanel } from "./extras/offcanvas/QuickPanel";
import { QuickUser } from "./extras/offcanvas/QuickUser";
import { ScrollTop } from "./extras/ScrollTop";
import Footer from "./footer/Footer";
import { HeaderMobile } from "./header-mobile/HeaderMobile";
import { Header } from "./header/Header";
import { LayoutInit } from "./LayoutInit";

export function Layout({ children }) {
  const uiService = useHtmlClassService();

  const currentState = useSelector(state => state.auth, shallowEqual);

  // Layout settings (cssClasses/cssAttributes)
  const layoutProps = useMemo(() => {
    return {
      layoutConfig: uiService.config,
      selfLayout: objectPath.get(uiService.config, "self.layout"),
      asideDisplay: objectPath.get(uiService.config, "aside.self.display"),
      subheaderDisplay: objectPath.get(uiService.config, "subheader.display"),
      desktopHeaderDisplay: objectPath.get(
        uiService.config,
        "header.self.fixed.desktop"
      ),
      contentCssClasses: uiService.getClasses("content", true),
      contentContainerClasses: uiService.getClasses("content_container", true),
      contentExtended: objectPath.get(uiService.config, "content.extended")
    };
  }, [uiService]);

  return layoutProps.selfLayout !== "blank" ? (
    <>
      {/*begin::Main*/}
      <HeaderMobile />
      <div
        className={`side_wrap ${
          currentState.darkLightMode ? "lightMode" : ""
        } d-flex flex-column flex-root`}
      >
        {/*begin::Page*/}
        <div className="d-flex flex-row flex-column-fluid page">
          {layoutProps.asideDisplay && <Aside />}
          {/*begin::Wrapper*/}
          <div
            className="d-flex flex-column flex-row-fluid wrapper"
            id="kt_wrapper"
          >
            <Header showSubheader={layoutProps.subheaderDisplay} />
            {/*begin::Content*/}
            <div
              id="kt_content"
              className={`content ${layoutProps.contentCssClasses} d-flex flex-column flex-column-fluid`}
            >
              {/*begin::Entry*/}
              {!layoutProps.contentExtended && (
                <div
                  id="kt_content_scroll_inner"
                  className="d-flex flex-column-fluid"
                >
                  {/*begin::Container*/}
                  <div className={layoutProps.contentContainerClasses}>
                    {children}
                  </div>
                  {/*end::Container*/}
                </div>
              )}

              {layoutProps.contentExtended && { children }}
              {/*end::Entry*/}
            </div>
            {/*end::Content*/}
            <Footer />
          </div>
          {/*end::Wrapper*/}
        </div>
        {/*end::Page*/}
        {/* <div className="button-cover">
                    <div className="button r" onClick={handleToggle} id="button-9">
                    <input type="checkbox" className="checkbox"/>
                    <div className="knobs"></div> 
                    <div className="layer"></div>
                    <span className="lightmode">Light</span>
                    <span  className="drakmode">Drak </span>
                    </div>
                    
                </div> */}
      </div>
      <QuickUser />
      <QuickPanel />
      <ScrollTop />
      {/*end::Main*/}
      <LayoutInit />
    </>
  ) : (
    // BLANK LAYOUT
    <div className="d-flex flex-column flex-root">{children}</div>
  );
}
